<template>
  <div>

    <div class="flex mb-4" style="align-items: center;">
      <h5>수시위험성평가</h5>
      <vs-spacer></vs-spacer>
      <vs-button color="secondary" @click="showApproval">결재 프로세스</vs-button>
    </div>
    <div style="margin-left:-1.2rem; margin-right:-1.2rem; padding:1.2rem; background: #fff;">
      <div class="flex mb-6" style="justify-content: flex-end;">
        <vs-button class="w-1/2 mr-2" color="secondary" type="border" @click="back">목록</vs-button>
        <vs-button class="w-1/2 ml-2" color="secondary" v-if="board.savable" @click="handleClickUpdate">임시저장</vs-button>
        <vs-button v-if="board.resend" class="w-1/2 ml-2" color="secondary" @click="handleClickRegister">임시저장 후 재상신</vs-button>
      </div>

      <vs-row class="mb-4">
        <vs-col><h5><i class="dot"></i>기본정보</h5></vs-col>
      </vs-row>

      <vs-row class="mb-4 flex flex-wrap" >
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">사무소명</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" :value="projectInfo.field_name" :readonly="true"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">차수</vs-col>
          <vs-col class="w-9/12">
            <order-number-select-module class="w-full" v-model="form.orderNumber" :readonly="board.readonly" @handleChange="handleChangeOrderNumber"/>
          </vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">대상기간</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.date" :readonly="true"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">위치/장소</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.location" :readonly="true"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">대상공종</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.processType" :readonly="board.readonly"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">세부공종</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.subProcessType" :readonly="board.readonly"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">작성자</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.writer" :readonly="true"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">소속</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.company" :readonly="true"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">예정공정표 첨부</vs-col>
          <vs-col class="w-9/12 flex">
            <file-uploader class="w-full" v-model="form.attach" :readonly="board.readonly"></file-uploader>
          </vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">작성일</vs-col>
          <vs-col class="w-9/12">
            <date-selector class="w-full" v-model="form.created_at" :readonly="true"/>
          </vs-col>
        </vs-row>
      </vs-row>

      <!-- 위험성 평가서 -->
      <vs-row class="mb-4">
        <vs-col class="flex mb-2">
          <h5><i class="dot"></i>위험성 평가서</h5>
        </vs-col>
        <vs-col class="flex">
          <vs-spacer></vs-spacer>
          <a v-if="!board.readonly" @click="handleShowTemplatePopup" style="color:#6670CB;">대상공정 추가 +</a>
          <span v-if="!board.readonly" class="mx-4">|</span>
          <a v-if="!board.readonly" @click="handleClickAddEval" style="color:#6670CB;">항목 추가 +</a>
          <span v-if="!board.readonly" class="mx-4">|</span>
          <a v-if="!board.readonly" @click="handleClickRemoveEval" style="color:#6670CB;">선택삭제 -</a>
        </vs-col>
      </vs-row>

      <vs-row class="border mb-8">
        <vs-col style="overflow-x: auto;">
          <ul class="table table-disaster">
            <li>
              <span class="title" style="min-width:60px;">
                <vs-checkbox v-model="evalAllCheck" @change="changeEvalAllCheck"></vs-checkbox>
              </span>
              <span class="title" style="min-width:150px;">단위공정</span>
              <span class="title" style="min-width:150px;">위험요인</span>
              <span class="title" style="min-width:150px;">재해형태</span>
              <span class="title" style="min-width:150px;">안전보건대책</span>
              <span class="title" style="min-width:150px;">담당자</span>
              <span class="title" style="min-width:80px;">위험등급</span>
            </li>

            <risk-assessment-eval-table-list :key="`eval_${i}`" v-for="(data, i) in evalList"
                                             v-if="evalList[i].is_show"
                                             v-model="evalList[i]"
                                             :readonly="board.readonly"
                                             :one-head="true"
                                             @handleChangeChecked="handleEvalChangeChecked"
            ></risk-assessment-eval-table-list>
          </ul>
        </vs-col>
      </vs-row>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination
            :total="lastPage"
            v-model="currentPage"
            @change="onChangePagination"
          ></k-pagination>
        </div>
      </div>

    </div>
    <vs-row :class="isShowApproval?'':'hidden'" style="position:fixed; top:0; left:0; bottom:0; right:0; z-index:45000; background: rgba(0,0,0,0.7); ">
      <div style="position: relative; width: 100%; height:100%; display: grid; grid-template-rows: 110px; minmax(0%,100%); overflow-y: auto;">
        <vs-spacer @click="hideApproval"></vs-spacer>
        <approval-process-module
          :board = "board"
          :commentabled="(!board.isCompleteApproval || board.savable)"

          @handleClickUpload="handleClickUpload"
          @handleClickOk="handleClickOk"
          @handleClickNo="handleClickNo"
          @handleSendApprovalProcess = "handleSendApprovalProcess"
        ></approval-process-module>
        <a style="width:33px; height:33px; position:absolute; top:77px; right:10px;"  @click="hideApproval">
          <i class="vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null" style="background: rgb(255, 255, 255);">close</i>
        </a>
      </div>

    </vs-row>

    <popup-std-safety-work-process
      :popupActive="popupActive"
      size="mobile"
      @popupActiveSync="popupActiveSync"
      @handleSendApprovalProcess="handleSendApprovalProcess"
      @handleItemClickDetail="handleItemClickDetail"
    ></popup-std-safety-work-process>

    <!-- TODO : 얼럿데이터 -->
    <popup-alert v-model="alert.show"
                 :is-confirm="alert.isConfirm"
                 :html="alert.html"
                 :message="alert.message"
                 :buttons="alert.buttons"

                 @ok="alertOk"
                 @no="alertNo"
    ></popup-alert>

  </div>
</template>

<script>
import DateSelector from '@/views/components/DateSelector'
import FileUploadModule from '@/views/modules/FileUploadModule'
import MemberSelector from '@/views/components/MemberSelector'
import ApprovalProcessModule from '@/views/modules/ApprovalProcessModule'
import OrderNumberSelectModule from '@/views/modules/OrderNumberSelectModule'
import FileUploader from '@/views/components/FileUploader'
import PopupStdSafetyWorkProcess from '@/views/project/popup/PopupStdSafetyWorkProcess'
import PopupAlert from '@/views/components/popup/PopupAlert'
import WarningLvSelector from '@/views/components/WarningLvSelector'
import AutoCompletionTextField from '@/views/components/AutoCompletionTextField'
import DisasterTypeSelector from '@/views/components/DisasterTypeSelector'
import KPagination from '@/views/components/kPagination/kPagination'
import RiskAssessmentEvalTableList from '@/views/project/risk/assessment/components/RiskAssessmentEvalTableList'
export default {
  name: 'MobileSafetyRegularAssessmentUpdate',
  components: {
    RiskAssessmentEvalTableList,
    KPagination,
    DisasterTypeSelector,
    AutoCompletionTextField,
    WarningLvSelector,
    PopupAlert,
    PopupStdSafetyWorkProcess,
    FileUploader,
    OrderNumberSelectModule,
    ApprovalProcessModule,
    MemberSelector,
    FileUploadModule,
    DateSelector},
  computed: {
    projectInfo () {
      return this.$store.state.project.projectInfo
    },

    memberAll () {
      const memberAll = []
      for (const member of this.$store.state.project.projectUserList) {
        memberAll.push({text:member.name, value:member.id})
      }

      return memberAll
    }
  },
  data () {
    return {
      boardSlug: 'always_risk',

      // TODO : 글쓰기 정보 및 권한
      board:{
        slug:'always_risk',
        statusCode: '', // 문서 상태코드
        writer: {}, //작성자 정보
        turnApprovalId: 0, // 결재자 ID
        readonly: false, // 읽기전용인가
        resend: false, // 재등록 가능한가
        isWriter: true, // 작성자인가
        savable: true, // 임시저장이 가능하나
        isCompleteApproval: false, // 결재완료된 문서인가
        isTurnApproval: false, // 결재할 차례인가
        approvalLine:[], // 결재라인
        commentList:[] // 댓글리스트
      },

      // TODO : 얼럿데이터
      alert:{
        show:false,
        message:'결재하시겠습니까?',
        buttons:[
          { label:'승인', action:'ok' },
          { label:'취소', action:'cancel' }
        ]
      },

      lastPage: 1,
      currentPage: 1,
      perPage:4,
      hideStdSafetyProc: false,

      popupActive:false,
      form :{
        project_title:'', //사무소명
        writer:'', //작성자
        processType:'', //대상공종
        company:'', //파트너사
        orderNumberId:'', //차수
        orderNumber:'', //차수
        attach:{}, //첨부
        date:'', //대상기간
        sdate:'',
        edate:'',
        issueList:[], // 위험평가서 이슈 리스트
        evalList:[], //위험성평가서 작성 리스트

        preview:{
          title:'',
          company:'',
          processType:'',
          orderNumber:'',
          sdate:'',
          writer:'',
          status:''
        }
      },

      evalAllCheck: false,
      evalList: [],

      isShowApproval:false
    }

  },

  mounted () {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {

      if (JSON.stringify(this.oldForm) === JSON.stringify(this.form)) {
        next(true); return
      } else if (confirm('저장하지 않은 데이터는 삭제됩니다. 닫으시겠습니까?')) {
        next(true); return
      }

      next(false)
    })
    this.$once('hook:destroyed', () => {
      backButtonRouteGuard()
    })
  },

  async created () {
    // 초기화
    await this.init()

    await this.loadPost()

    // 전체 참여 인원
    await this.loadMemberAll()

    this.oldForm = JSON.parse(JSON.stringify(this.form))
  },
  methods:{
    async init () {
      await this.$store.dispatch('USER_INFO')
      this.board.writer = {
        id: this.$store.state.auth.userInfo.id,
        name: this.$store.state.auth.userInfo.name,
        company_id: this.$store.state.auth.userInfo.company_id,
        company_name: this.$store.state.auth.userInfo.company_name
      }
      await this.$store.dispatch('company/LOAD_COMPANY', {companyId:this.board.writer.company_id})
      this.board.writer.company_name = this.$store.state.company.companyInfo.com_name
    },
    async loadPost () {
      const boardSlug = this.boardSlug
      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/LOAD_POST', {boardSlug, postId})

      if (!this.$store.state.approval.postInfo) {
        alert('열람 권한이 없습니다.')
        this.oldForm = this.form
        this.$router.back()
        return
      }
      const post = JSON.parse(this.$store.state.approval.postInfo.post_content)
      this.form = post

      // TODO : 결재프로세스
      await this.$store.dispatch('USER_INFO')
      const myId = this.$store.state.auth.userInfo.id
      const doc = this.$store.state.approval.document
      this.board.statusCode = doc.status.code
      this.board.writer = doc.writer
      this.board.turnApprovalId = doc.turn_approval_id
      this.board.isWriter = (this.board.writer.id === myId)
      this.board.isTurnApproval = (this.board.turnApprovalId === myId && (this.board.statusCode === 'registered' || this.board.statusCode === 'ongoing'))
      this.board.readonly = !((this.board.isWriter && (this.board.statusCode === 'temp' || this.board.statusCode === 'rejected')) || this.board.isTurnApproval)
      this.board.resend = (this.board.isWriter && this.board.statusCode === 'rejected')
      this.board.isCompleteApproval = (this.board.statusCode === 'approved' || this.board.statusCode === 'rejected')
      this.board.savable = this.board.isWriter && (this.board.statusCode === 'temp')
      this.board.collection = this.board.isWriter && (this.board.statusCode === 'registered')
      this.board.approvalLine = doc.line.slice() // 모듈 표기용
      this.approvalLine = doc.line.slice() // api 전송용

      if (this.board.isWriter) {
        this.evalList = this.form.evalList
      } else {
        this.readonlyEvalList = this.form.evalList
      }

      this.oldForm = JSON.parse(JSON.stringify(this.form))
      this.oldEvalList = JSON.parse(JSON.stringify(this.evalList))
      //this.addEvalEmpty()

      this.makeTable()
      this.updateLastPage()
    },

    back () {
      this.$router.back()
    },

    async register (isUploaded) {
      if (isUploaded && (!this.approvalLine || this.approvalLine.length === 0)) {
        alert('결재선을 지정해주세요')
        return
      }
      if (isUploaded && !this.form.orderNumber) {
        alert('차수를 선택하세요.')
        return
      }

      // 등록정보
      const boardSlug = this.boardSlug
      const postId = this.$route.params.postId
      const title = this.form.project_title
      const approvalLine = JSON.stringify(this.lineToSendLine(this.approvalLine))
      const projectId = this.$route.params.proj_id
      const projectOrderId = this.form.orderNumberId

      // 리스트 노출 정보
      this.form.preview.title = this.form.project_title
      this.form.preview.company = this.form.company
      this.form.preview.processType = this.form.processType
      this.form.preview.orderNumber = this.form.orderNumber
      this.form.preview.date = this.form.date
      this.form.preview.writer = this.form.writer
      this.form.evalList = this.evalList
      const content = JSON.stringify(this.form)

      try {
        if (isUploaded) {
          // 바로 상신하기
          const unTemp = 'y'
          await this.$store.dispatch('approval/UPDATE_POST', {boardSlug, postId, title, content, approvalLine, projectId, projectOrderId, unTemp})
          alert('상신되었습니다.')
          this.oldForm = JSON.parse(JSON.stringify(this.form))
          this.back()
        } else {
          // 임시 저장하기
          const unTemp = 'n'
          await this.$store.dispatch('approval/UPDATE_POST', {boardSlug, postId, title, content, approvalLine, projectId, projectOrderId, unTemp})
          alert('임시저장되었습니다.')
          this.oldForm = JSON.parse(JSON.stringify(this.form))
          this.back()
        }

      } catch (e) {
        if (this.$store.state.approval.error_data.title) {
          alert('사무소명이 없습니다')
        } else {
          console.log(this.$store.state.approval.error_code)
        }
      }


      //this.back()

    },
    async reRegister (isUploaded) {
      if (isUploaded && (!this.approvalLine || this.approvalLine.length === 0)) {
        alert('결재선을 지정해주세요')
        return
      }

      // 등록정보
      const boardSlug = this.boardSlug
      const title = this.projectInfo.field_name
      const approvalLine = JSON.stringify(this.lineToSendLine(this.approvalLine))
      const security = 'normal' // 문서보안 등급 ['일반', 대외비 1급, 대외비 2급, 인비, 극비] [normal,confidential1,confidential2,personally,confidential0]
      const priority = 'medium' // 문서 중요도 [매우낮음, 낮음, 보통, 높음, 매우 높음] [lowest,low,medium,high,highest]
      const projectId = this.$route.params.proj_id
      const projectOrderId = this.form.orderNumberId

      // 리스트 노출 정보
      this.form.project_title = title
      this.form.preview.title = this.form.project_title
      this.form.preview.company = this.form.company
      this.form.preview.processType = this.form.processType
      this.form.preview.orderNumber = this.form.orderNumber
      this.form.preview.date = this.form.date
      this.form.preview.writer = this.form.writer
      this.form.evalList = this.evalList
      const content = JSON.stringify(this.form)


      try {
        if (isUploaded) {
          // 바로 상신하기
          await this.$store.dispatch('approval/CREATE_POST', {boardSlug, title, content, approvalLine, security, priority, projectId, projectOrderId})
          alert('상신되었습니다.')
          this.oldForm = JSON.parse(JSON.stringify(this.form))
          this.back()
        } else {
          // 임시 저장하기
          const isTemp = 1
          await this.$store.dispatch('approval/CREATE_POST', {boardSlug, title, content, approvalLine, security, priority, projectId, projectOrderId, isTemp})
          alert('임시저장되었습니다.')
          this.oldForm = JSON.parse(JSON.stringify(this.form))
          this.back()
        }

      } catch (e) {
        if (this.$store.state.approval.error_data.title) {
          alert('사무소명이 없습니다')
        } else {
          console.log(this.$store.state.approval.error_code)
        }
      }


      //this.back()

    },

    async loadMemberAll () {
      const page = 1
      const perPage = 100
      const projectId = this.$route.params.proj_id
      await this.$store.dispatch('project/LOAD_PROJECT_USER', {page, perPage, projectId})
    },

    showApproval () {
      this.isShowApproval = true
    },

    hideApproval () {
      this.isShowApproval = false
    },

    popupActiveSync () {
      this.popupActive = false
    },

    handleClickAddEval () {
      this.addEvalEmpty()
    },

    addEvalEmpty () {
      this.addEval('', '', '', '', '', '')
    },

    handleClickRemoveEval () {
      for (let i = 0; i < this.evalList.length; i++) {
        if (this.evalList[i].is_checked) {
          this.evalList.remove(this.evalList[i])
          i = -1
        }
      }

      this.evalAllCheck = false
      this.updateLastPage()
    },

    handleShowTemplatePopup () {
      this.popupActive = true
    },
    handleBackMenu () {
      this.$emit('handleBackMenu', 'regular')
    },
    handleHideStdSafetyProc () {
      this.hideStdSafetyProc = !this.hideStdSafetyProc
    },

    handleClickUpdate () {
      if (confirm('저장하시겠습니까?')) {
        this.register(false)
      }
    },

    handleClickRegister () {
      if (confirm('임시저장 하시겠습니까?')) {
        this.reRegister(false)
      }
    },

    // TODO : 결재프로세스

    // ApprovalProcessModule 에서 사용하는 line 방식에서 전송용 line 으로 변경
    lineToSendLine (data) {
      const approvalList = []

      for (const member of data) {
        if (member.type_code !== 'register') {
          approvalList.push({
            id : member.user_id,
            name : member.user_name,
            elementType : member.type_code
          })
        }
      }

      return approvalList
    },

    isCompleteApproval () {
      return (this.line[this.line.length - 1].status_id === 2)
    },
    handleSendApprovalProcess (approvalLine) {
      this.approvalLine = approvalLine
    },
    handleClickNo () {
      this.alert.html = '<p>반려하시겠습니까?</p><p>아래에 사유를 작성해주세요.</p>'
      this.alert.message = ''
      this.alert.isConfirm = true
      this.alert.buttons = [
        { label:'반려', action:'no' },
        { label:'취소', action:'cancel', type:'border' }
      ]
      this.alert.show = true
    },
    async handleClickOk () {
      this.alert.html = ''
      this.alert.message = '승인하시겠습니까?'
      this.alert.isConfirm = false
      this.alert.buttons = [
        { label:'승인', action:'ok' },
        { label:'취소', action:'cancel', type:'border' }
      ]
      this.alert.show = true

    },
    handleClickUpload () {
      if (confirm('상신하시겠습니까?')) {
        this.register(true)
      }
    },


    // TODO : 얼럿데이터
    async alertOk () {

      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/APPROVE_OK', {
        postId
      })

      this.oldForm = JSON.parse(JSON.stringify(this.form))
      document.location.reload()
    },

    async alertNo (text) {
      const postId = this.$route.params.postId
      const comment = text
      await this.$store.dispatch('approval/APPROVE_NO', {
        postId,
        comment
      })
      document.location.reload()
    },

    handleItemClickDetail (data) {
      const unit_task = data.unit_task.name
      const work_img = data.photos[0].path
      const work_flow = data.work_flow
      const work_risk = data.work_risk
      const work_safety_measure = data.work_safety_measure


      this.addIssue(1, work_img, work_flow, unit_task, work_risk, work_safety_measure, '', '', '')

    },

    handleClickAddIssue () {
      this.addIssue(2, '', '', '', '', '', '', '', '')
    },

    handleEvalChangeChecked () {
      let count = 0
      for (const data of this.evalList) {
        if (data.is_checked === true) {
          count++
        }
      }
      this.evalAllCheck = (Number(count) === Number(this.evalList.length))
    },

    handleChangeOrderNumber (data) {
      this.orderNumberId = data.id
      this.orderNumber = data.order_number
      this.form.sdate = data.begin_ymd.substr(0, 10)
      this.form.edate = data.end_ymd.substr(0, 10)
      this.form.date = `${this.form.sdate} ~ ${this.form.edate}`
    },

    // 글 삭제
    async handleDeletePost (_postId) {
      const boardSlug = this.boardSlug
      const postId = this.$route.params.postId
      if (_postId <= 0) {
        return
      }
      await this.$store.dispatch('approval/DELETE_POST', {boardSlug, postId})

      this.$router.back()
    },

    changeEvalAllCheck () {

      // 전체 페이지 체크
      for (const data of this.evalList) {
        data.is_checked = this.evalAllCheck
      }
    },

    changeSDate (ii, ci, data) {
      const cDate = new Date(data)
      const sDate = new Date(this.form.sdate)
      const eDate = new Date(this.form.edate)

      if (cDate - sDate >= 0
        && cDate - eDate <= 0) {
        this.form.issueList[ii].contents[ci].processor_1.sdate = cDate.format('yyyy-MM-dd')
      } else {
        alert('대상기간 범위로 선택해주세요')
        this.form.issueList[ii].contents[ci].processor_1.sdate = ''
      }
    },

    changeEDate (ii,ci, data) {
      const cDate = new Date(data)
      const sDate = new Date(this.form.sdate)
      const eDate = new Date(this.form.edate)

      if (cDate - sDate >= 0
        && cDate - eDate <= 0) {
        this.form.issueList[ii].contents[ci].processor_1.edate = cDate.format('yyyy-MM-dd')
      } else {
        alert('대상기간 범위로 선택해주세요')
        this.form.issueList[ii].contents[ci].processor_1.edate = ''
      }
    },

    changeWorkSDate (ii, data) {
      const cDate = new Date(data)
      const sDate = new Date(this.form.sdate)
      const eDate = new Date(this.form.edate)

      if (cDate - sDate >= 0
        && cDate - eDate <= 0) {
        this.form.issueList[ii].work_sdate = cDate.format('yyyy-MM-dd')
      } else {
        alert('대상기간 범위로 선택해주세요')
        this.form.issueList[ii].work_sdate = ''
      }
    },

    changeWorkEDate (ii, data) {
      const cDate = new Date(data)
      const sDate = new Date(this.form.sdate)
      const eDate = new Date(this.form.edate)

      if (cDate - sDate >= 0
        && cDate - eDate <= 0) {
        this.form.issueList[ii].work_edate = cDate.format('yyyy-MM-dd')
      } else {
        alert('대상기간 범위로 선택해주세요')
        this.form.issueList[ii].work_edate = ''
      }
    },

    makeTable () {
      for (let i = 0; i < this.evalList.length; i++) {
        const page = Math.floor(i / this.perPage) + 1
        this.evalList[i].is_show = (page === this.currentPage)
      }
    },

    updateLastPage () {
      this.lastPage = this.evalList.length > 0 ? (Math.floor((this.evalList.length - 1) / this.perPage)) + 1 : 1
    },

    onChangePagination (page) {
      this.currentPage = page

      this.makeTable()
    }
  }
}
</script>
<style scoped>
[dir] ul.table.table-disaster > li {
  grid-template-columns: 60px 1fr 1fr 1fr 1fr 1fr 80px;
}
</style>
